//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import {
  ILabelIndexObject,
  ILabelsSortField,
  LabelsSortField,
} from '@apis/gatewayMediaApiModel';

// Sort `labels` by field and corresponding sort direction defined as `sortField`.
export const sortLabels = (
  labels: ILabelIndexObject[],
  sortField: ILabelsSortField,
) => {
  const getField = (label: ILabelIndexObject, sortField: LabelsSortField) => {
    switch (sortField) {
      case LabelsSortField.ItemsWithTag:
        return label.itemsWithTag;
      case LabelsSortField.LastUsed:
        return label.lastUsed;
      case LabelsSortField.UserTag:
        return label.userTag;
    }
  };

  return labels.sort((first, second) => {
    const { field, isAscending } = sortField;

    if (field === LabelsSortField.UserTag) {
      return isAscending
        ? second.userTag.localeCompare(first.userTag)
        : first.userTag.localeCompare(second.userTag);
    } else {
      const firstField = getField(first, field);
      const secondField = getField(second, field);

      if (firstField < secondField) {
        return isAscending ? -1 : 1;
      }

      if (firstField > secondField) {
        return isAscending ? 1 : -1;
      }
    }

    return 0;
  });
};
